<template>
  <div>
    <SpinnerLoading v-if="isLoading" color="blue" style="margin-top: 58px;" />
    <div v-else class="schedule-editor">
      <div class="time-row">
        <label class="time-label">Время начала</label>
        <input
          v-model="localFrom"
          type="time"
          class="time-input"
          :class="{ 'error-input': timeErrors.from }"
        >
      </div>
      <div class="time-row">
        <label class="time-label">Время окончания</label>
        <input
          v-model="localTo"
          type="time"
          class="time-input"
          :class="{ 'error-input': timeErrors.to }"
        >
      </div>
      <p v-if="timeErrors.to" class="error-msg">
        {{ timeErrors.to }}
      </p>
      <div class="days-selector">
        <button
          v-for="(day, index) in localDays"
          :key="index"
          class="day-button"
          :class="{ active: day.enabled }"
          @click="toggleDay(index)"
        >
          {{ day.label }}
        </button>
      </div>
      <div class="actions">
        <button class="primary" @click="save">
          Сохранить
        </button>
        <button @click="cancel">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {ACTION_CREATE_SCHEDULE, DAYS_OF_WEEK} from "@/store/analytics/schedules/index.js";
/**
 *  Компонент создания расписания
 *
 **/
export default {
  name: 'ScheduleAnalytics',
  props: {
    analyticType: String,
    cameraNumber: String,
    from: {
      type: String,
      default: '09:00',
    },
    to: {
      type: String,
      default: '18:00',
    },
  },
  data() {
    return {
      isLoading: false,
      localFrom: this.from,
      localTo: this.to,
      localDays: DAYS_OF_WEEK.map(day => ({
        ...day,
        enabled: false,
      })),
      timeErrors: {
        from: '',
        to: '',
      },
    };
  },
  methods: {
    async save() {
      this.isLoading = true;
      const selectedLabels = this.localDays
        .filter(day => day.enabled)
        .map(day => day.label);
      // Сброс ошибок
      this.timeErrors.from = '';
      this.timeErrors.to = '';
      try {
        await this.$store.dispatch(`analytics/schedules/${ACTION_CREATE_SCHEDULE}`, {
          cameraNumber: this.cameraNumber,
          scheduleType: this.analyticType,
          schedule: {
            from: this.localFrom,
            to: this.localTo,
            days: selectedLabels,
          },
        });
        this.$emit('save');
      } catch (e) {
        console.error("Ошибка при создании расписания", e);
        const serverFields = e?.fields || e?.response?.data?.fields;
        const timeErrorMsg = serverFields?.settings?.[0]?.start_time?.[0];
        if (timeErrorMsg) {
          this.timeErrors.from = timeErrorMsg;
          this.timeErrors.to = timeErrorMsg;
        } else {
          this.timeErrors.to = 'Ошибка при создании расписания';
        }
      }
      this.isLoading = false;
    },
    cancel() {
      this.$emit('cancel');
    },
    toggleDay(index) {
      this.localDays[index].enabled = !this.localDays[index].enabled;
    },
  },
};
</script>

<style scoped>
.schedule-editor {
  padding: 6px;
  font-family: Arial, sans-serif;
}

.time-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.time-label {
  font-size: 14px;
  color: #6b7280;
}

.time-input {
  width: 100px;
  height: 32px;
  padding: 4px;
  font-size: 14px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  box-sizing: border-box;
}

.days-selector {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
  margin-bottom: 24px;
}

.day-button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  font-size: 14px;
  cursor: pointer;
  color: #374151;
  background-color: #f1f5f9;
  transition: all 0.2s ease;
}

.day-button.active {
  background-color: #2f80ed;
  color: white;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.actions button {
  padding: 8px 16px;
  font-size: 14px;
  border-radius: 20px;
  border: 1px solid #2f80ed;
  background-color: white;
  color: #2f80ed;
  cursor: pointer;
}

.actions .primary {
  background-color: #2f80ed;
  color: white;
  border: none;
}
.error-msg {
  color: red;
  font-size: 13px;
  margin-top: -12px;
  margin-bottom: 12px;
  text-align: center;
}

.error-input {
  border-color: red !important;
}
</style>
